import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChatClientPanelComponent } from './chat-client-panel.component';

@NgModule({
  declarations: [ChatClientPanelComponent],
  imports: [CommonModule],
  exports: [ChatClientPanelComponent],
})
export class ChatClientPanelModule {}
